module.exports = __webpack_public_path__ + "static/media/S (81).76565eef.jpg";